<template>
  <div>

    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0" style="height: 90vh">
        <div class="shape shape-style-1 shape-default">
        </div>
        <div class="container shape-container d-flex">
          <div class="align-items-center row">
            <div class="p-sm-0 col-lg-12 align-content-center">
              <div class="col-7">
                <div class="text-main-color h1" style="word-break: keep-all">
                  紫微飛星
                </div>
              </div>
              <div class="col-4">
                <base-button @click="clickGotoUse">前往使用</base-button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import Glide from "@/components/Glide";

export default {
  name: "home",
  components: {Glide: Glide},
  methods: {
    clickGotoUse() {
      window.open('https://app.ziwei-flying.com/web-wvvyfzdi/#/', '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.message {
  //  background: url("/img/brand/message.svg");
  //  background-repeat: no-repeat;
  //  background-position: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.8rem;
}

.mb-150 {
  margin-bottom: 150px;
}
.section-shaped .shape {
  height: 100%;
}
</style>
